enum BaseDirectory {
  ORG = "organization",
  RAW = "raw",
  STANDARD = "standardized",
  ENRICHED = "enriched",
  STUDY_MANAGEMENT = "study_management",
  PROJECT = "workbench",
  PROJECTS = "workbenches",
  PERSONAL = "personal",
  CURRENT_DATASET = "current-dataset",
}

export default BaseDirectory;
